import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ProfileService } from '@features/profile/profile.service';

@Component({
  standalone: false,
  selector: 'ingsv-adm-input-actions',
  templateUrl: './input-actions.component.html',
  styleUrls: ['./input-actions.component.scss']
})
export class InputActionsComponent implements OnChanges, OnInit {
  @Input() dataToSet: any;
  @Input() label: string;
  @Input() loader = false;
  @Input() inputType = 'text';

  @Output() inputChanged = new EventEmitter<any>();

  editView = false;
  data = '';

  constructor(
    public profileService: ProfileService
  ) {}

  ngOnInit() {}

  ngOnChanges(changes: any) {
    if (this.dataToSet || this.dataToSet === 0) {
      this.data = this.dataToSet;
    }
  }

  editData() {
    this.inputChanged.emit(this.data);
  }

  editTextView() {
    if (!this.profileService.isTextHighlighted()) {
      this.editView = !this.editView;
    }
  }

  cancel(): void {
    this.editView = false;
  }
}
